import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const ProtectedRoute = ({ children, permissions = [], roles = [], requireAuth = true }) => {
    const { Authorised, hasPermission, hasRole, isLoading } = useContext(AuthContext);

    if (isLoading) {
        // You can return a loading spinner here
        return <div>Loading...</div>;
    }

    if (requireAuth && !Authorised) {
        return <Navigate to="/" replace />;
    }

    // Bypass checks for Super Admin and Admin
    if (hasRole('Super Admin') || hasRole('Admin')) {
        return children;
    }

    if (permissions.length > 0) {
        const hasRequiredPermission = permissions.some(p => hasPermission(p));
        if (!hasRequiredPermission) {
            // Redirect to dashboard or a 403 page
            return <Navigate to="/dashboard" replace />;
        }
    }

    // Role check is properly deprecated in favor of permissions
    // But we keep Admin bypass above.

    return children;
};

export default ProtectedRoute;
